import HttpService from './http';

export default class CategoryHttpService {
  static get = async uid => {
    const url = `/v2.0/categories/${uid}`;
    return await HttpService.get(url, false);
  };

  static listOfEvent = async event_uid => {
    const url = `/v2.0/categories/event/${event_uid}`;
    return await HttpService.get(url, false);
  };

  static post = async payload => {
    const url = '/v2.0/categories';
    return await HttpService.post(url, payload, true);
  };
}
